import Vue from 'vue'
import VueRouter from 'vue-router'
import two from '@/pages/two'
import one from '@/pages/one'
import sign from '@/pages/sign/index'
import guide from '@/pages/guide/index'
import home from '@/pages/home/index'
// import map from '@/pages/menu/map/map'
import userDetails from '@/pages/menu/personal/userDetails'
import company from '@/pages/menu/maintenance/company'
import companyDetails from '@/pages/menu/maintenance/companyDetails'
import workOrder from '@/pages/menu/maintenance/workOrder'
import workOrderDetails from '@/pages/menu/maintenance/workOrderDetails'

import user from '@/pages/menu/personal/user'
import personalCenter from '@/pages/menu/personal/personalCenter'

import toiletInfo from '@/pages/menu/toilet/toiletInfo'
import toiletDetail from '@/pages/menu/toilet/toiletDetail'
import toiletDetail2 from '@/pages/menu/toilet/toiletDetail2'
import ToiletPv from '@/pages/menu/toilet/toiletPv'
import toiletAnalysis from '@/pages/menu/toilet/toiletAnalysis'
import toileUseThePaper from '@/pages/menu/toilet/toileUseThePaper'
import toiletMap from '@/pages/menu/toilet/toiletMap'
import workorderSummaryReport from '@/pages/menu/statisticalReport/workorderSummaryReport'
import workorderLag from '@/pages/menu/statisticalReport/workorderLag'
import inspection from '@/pages/menu/statisticalReport/inspection'
import perationoPersonnel from '@/pages/menu/statisticalReport/perationoPersonnel'
import vacuumDrainageReport from '@/pages/menu/statisticalReport/vacuumDrainageReport'
import collectWellReport from '@/pages/menu/statisticalReport/collectWellReport'

Vue.use(VueRouter)

// assembly:全局组件引用(头部侧栏) true显示/false隐藏

const routes = [
  {path: '/one', name: 'one', component: one, meta: {assembly: false}},
  {path: '/two', name: 'two', component: two, meta: {assembly: false}},
  {path: '/guide', name: 'guide', component: guide, meta: {assembly: false}},
  {path: '/home', name: 'home', component: home, meta: {assembly: false}},
  {path: '/toiletInfo', name: '2-1', component: toiletInfo, meta: {toiletType: 1, assembly: true}},
  {path: '/toiletDetail', name: '2-1', component: toiletDetail, meta: {assembly: true}},
  {path: '/toiletDetail2', name: '2-1', component: toiletDetail2, meta: {assembly: true}},
  {path: '/toiletPv', name: '2-1', component: ToiletPv, meta: {assembly: true}},
  {path: '/toiletMap', name: '2-1', component: toiletMap, meta: {assembly: true}},
  {path: '/company', name: '3-1', component: company, meta: {assembly: true}},
  {path: '/companyDetails', name: '3-1', component: companyDetails, meta: {assembly: true}},
  {path: '/workOrder', name: '3-1', component: workOrder, meta: {assembly: true}},
  {path: '/workOrderDetails', name: '3-1', component: workOrderDetails, meta: {assembly: true}},
  {path: '/toiletAnalysis', name: '4-1', component: toiletAnalysis, meta: {assembly: true}},
  {path: '/toileUseThePaper', name: '4-1', component: toileUseThePaper, meta: {assembly: true}},
  {path: '/workorderSummaryReport', name: '4-1', component: workorderSummaryReport, meta: {assembly: true}},
  {path: '/workorderLag', name: '4-1', component: workorderLag, meta: {assembly: true}},
  {path: '/inspection', name: '4-1', component: inspection, meta: {assembly: true}},
  {path: '/perationoPersonnel', name: '4-1', component: perationoPersonnel, meta: {assembly: true}},
  {path: '/vacuumDrainageReport', name: '4-1', component: vacuumDrainageReport, meta: {assembly: true}},
  {path: '/collectWellReport', name: '4-1', component: collectWellReport, meta: {assembly: true}},


  {path: '/user', name: '5-1', component: user, meta: {assembly: true}},
  {path: '/userDetails', name: '5-1', component: userDetails, meta: {assembly: true}},
  {path: '/personalCenter', name: '5-1', component: personalCenter, meta: {assembly: true}},

  {path: '/', name: 'sign', component: sign, meta: {assembly: false}},
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//解决 Vue 重复点击相同路由，出现 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation  / 问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js